import styled from "styled-components";

import { DATA_E2E_KEY } from "@ryde/shared";
import { rydeColors } from "@ryde/theme";

export const WarningsDisplayRootEmptyStyled = styled.div.attrs({
  className: "cell_simple",
  [DATA_E2E_KEY]: "warnings-display-template-empty",
})``;

export const WarningsDisplayRootStyled = styled.div.attrs({
  className: "cell_simple",
  [DATA_E2E_KEY]: "warnings-display-template",
})`
  & .warnings-display-cell {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: ${rydeColors.orange};
    font-weight: 500;
  }

  & .warnings-display-count {
    font-size: 12px;
    line-height: 1;
  }
`;

export const WarningsTooltipStackStyled = styled.div.attrs({
  className: "warnings-display-tooltip-stack",
  [DATA_E2E_KEY]: "warnings-display-tooltip-stack",
})`
  display: flex;
  flex-direction: column;
  gap: 2px;
  max-width: 320px;
  white-space: normal;
  text-align: start;
  line-height: 1.25;
`;
